




export const dummyDataPlaylists = [
    {
        id: '1',
        name: 'Playlist 1',
        image: require('../../assets/images/logic.jpg'),
    },
    {
        id: '2',
        name: 'Playlist 2',
        image: require('../../assets/images/odz.jpg'),
    },
    {
        id: '3',
        name: 'Playlist 3',
        image: require('../../assets/images/metallica.jpg'),
    },
    // make 5 more object like that
    {
        id: '4',
        name: 'Playlist 4',
        image: require('../../assets/images/dio.jpg'),
    },
    {
        id: '5',
        name: 'Playlist 5',
        image: require('../../assets/images/post.jpg'),
    },
    {
        id: '6',
        name: 'Playlist 6',
        image: require('../../assets/images/skepta.jpg'),
    }
];